import { TypeAnimation } from "react-type-animation";
import { useState, useEffect } from "react";

export default function TypingSequential({ isVisible }) {
    const lines = [
        'A fast-cut city day-to-night: commuters, skaters, creators — all styling the same oversized unisex blue puffer. Snap transitions, split-screen fits, subtle breath-in-cold shots. Ends on a wide shot: one jacket, many moods.'
        , 'Freeze-frame storm: lightning frozen like glass, raindrops suspended mid-air, a lone figure walking slowly. Soft cinematic lighting, dramatic shadows stretch across the ground, occasional gusts ripple clothing and hair.']

    const ghostText =
        isVisible ? `
    A fast-cut city day-to-night: commuters, skaters, creators — all styling the<br>
    same oversized unisex blue puffer. Snap transitions, split-screen fits, subtle<br>
    breath-in-cold shots. Ends on a wide shot: one jacket, many mo` :
            `A fast-cut city day-to-night: commuters, skaters,<br>
    creators — all styling the same oversized unisex<br>
    blue puffer. Snap transitions, split-screen fits,<br>
    subtle breath-in-cold shots. Ends on a wide shot:<br>
    one jacket, many mo`;


    const [index, setIndex] = useState(0);
    const [key, setKey] = useState(0);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (!done) return;

        const timer = setTimeout(() => {
            setIndex(prev => (prev + 1) % lines.length);
            setKey(prev => prev + 1);
            setDone(false);
        }, 5000);

        return () => clearTimeout(timer);
    }, [done]);
    return (
        <div className="typing-wrapper" style={{ position: "relative", display: "inline-block" }}>
            {/* <p
                className="ghost-text"
                dangerouslySetInnerHTML={{ __html: ghostText }}
            /> */}

            <div style={{ whiteSpace: "pre-wrap", position: "relative" }}>
                <TypeAnimation
                    key={key}
                    sequence={[
                        lines[index],
                        () => setDone(true)
                    ]}
                    speed={50}
                    cursor={true}
                    wrapper="p"
                />
            </div>
        </div>
    );
}
